import React, { useState } from "react";
import "./VotreFormulaire.css"; // Assurez-vous que le chemin est correct pour votre fichier CSS
import Contact from "./Contact";
import { Helmet } from "react-helmet-async";
import { getApiBaseUrl } from "./config/api";

function RepriseContent() {
  const [step, setStep] = useState(1);

  // Partie 1 - Modèle et mécanique
  const [marque, setMarque] = useState("");
  const [modele, setModele] = useState("");
  const [boiteVitesse, setBoiteVitesse] = useState("");
  const [carburant, setCarburant] = useState("");
  const [kilometrage, setKilometrage] = useState("");
  const [couleur, setCouleur] = useState("");
  const [options, setOptions] = useState("");
  const [puissance, setPuissance] = useState("");
  const [year, setYear] = useState("");
  const [immat, setImmat] = useState("");
  const [nom, setNom] = useState("");
  const [numeroTelephone, setNumeroTelephone] = useState("");
  const [website, setWebsite] = useState("");
  const [isSending, setIsSending] = useState(false);
  const [submitError, setSubmitError] = useState("");

  const validateForm = () => {
    if (nom.trim().length < 2) {
      setSubmitError("Indiquez votre nom.");
      return false;
    }
    if (!/^[+()\d .-]{8,30}$/.test(numeroTelephone.trim())) {
      setSubmitError("Indiquez un numéro de téléphone valide.");
      return false;
    }
    setSubmitError("");
    return true;
  };

  const nextStep = () => {
    window.scrollTo(0, 0);
    setStep(step + 1);
  };

  const prevStep = () => {
    window.scrollTo(0, 0);
    setStep(step - 1);
  };

  const sendForm = async () => {
    if (validateForm() && !isSending) {
      setIsSending(true);
      const data = {
        formulaire: "REPRISE",
        marque: marque,
        modele: modele,
        boiteVitesse: boiteVitesse,
        carburant: carburant,
        kilometrage: kilometrage,
        couleur: couleur,
        options: options,
        puissance: puissance,
        nom: nom,
        numeroTelephone: numeroTelephone,
        year: year,
        immat: immat,
        website,
      };

      // URL API depuis variable d'environnement
      const API_URL = getApiBaseUrl();
      
      try {
        const response = await fetch(`${API_URL}/api/sendEmail`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(data),
        });

        if (response.ok) {
          window.scrollTo(0, 0);
          setStep(3);
        } else {
          const result = await response.json().catch(() => ({}));
          setSubmitError(result.error || "L’envoi a échoué. Réessayez ou contactez-nous par téléphone.");
        }
      } catch (error) {
        console.error("Error:", error);
        setSubmitError("Connexion impossible. Réessayez ou contactez-nous au 06 82 75 46 29.");
      } finally {
        setIsSending(false);
      }
    }
    return null;
  };

  return (
    <div>
      <Helmet>
        <title>Reprise de véhicule | FLIP MY CAR</title>
        <meta name="description" content="Faites estimer votre véhicule pour une reprise chez FLIP MY CAR à Chambourcy (78). Estimation gratuite et rapide." />
        <link rel="canonical" href="https://flipmycar.fr/reprise" />
        <meta property="og:title" content="Reprise de véhicule | FLIP MY CAR" />
        <meta property="og:description" content="Faites estimer gratuitement votre véhicule pour une reprise par FLIP MY CAR." />
        <meta property="og:url" content="https://flipmycar.fr/reprise" />
        <meta property="og:type" content="website" />
        <meta property="og:image" content="https://flipmycar.fr/logo2.png" />
        <meta name="twitter:card" content="summary" />
        <meta name="twitter:title" content="Reprise de véhicule | FLIP MY CAR" />
        <meta name="twitter:description" content="Faites estimer gratuitement votre véhicule pour une reprise par FLIP MY CAR." />
      </Helmet>

      <div className="Reprise">
        <h1 className="RepriseTitle">Reprise de votre véhicule</h1>
        <p className="form-intro">
          Décrivez votre véhicule pour recevoir une estimation et être rappelé par notre équipe.
        </p>
        <div className="formulaire-container">
          <div>
            {/* Partie 1 */}
            {step === 1 && (
              <div className="form-step">
                <h2>Étape 1 - Votre véhicule</h2>
                <br></br>
                <label className="labelmenuderoulant">
                  <span className="label">Marque :</span>
                  <input
                    type="text"
                    value={marque}
                    onChange={(e) => setMarque(e.target.value)}
                  />
                </label>
                <label className="labelmenuderoulant">
                  <span className="label"> Modèle :</span>
                  <input
                    type="text"
                    value={modele}
                    onChange={(e) => setModele(e.target.value)}
                  />
                </label>
                <label className="labelmenuderoulant">
                  <span className="label">Transmission :</span>
                  <select
                    value={boiteVitesse}
                    onChange={(e) => setBoiteVitesse(e.target.value)}
                    className="menudroulant"
                  >
                    <option value="">Sélectionnez une boîte de vitesse</option>
                    <option value="Manuelle">Manuelle</option>
                    <option value="Automatique">Automatique</option>
                    {/* Ajoutez d'autres options au besoin */}
                  </select>
                </label>
                <label className="labelmenuderoulant">
                  <span className="label">Carburant :</span>
                  <select
                    value={carburant}
                    onChange={(e) => setCarburant(e.target.value)}
                    className="menudroulant"
                  >
                    <option value="">Sélectionnez un carburant</option>
                    <option value="Essence">Essence</option>
                    <option value="Hybride">Hybride</option>
                    <option value="Diesel">Diesel</option>
                    <option value="Electrique">Electrique</option>
                    {/* Ajoutez d'autres options au besoin */}
                  </select>
                </label>
                <label className="labelmenuderoulant">
                  <span className="label">Puissance en cv :</span>
                  <input
                    type="text"
                    value={puissance}
                    onChange={(e) => setPuissance(e.target.value)}
                  />
                </label>
                <label className="labelmenuderoulant">
                  <span className="label"> Kilométrage actuel : </span>
                  <input
                    type="text"
                    value={kilometrage}
                    onChange={(e) => setKilometrage(e.target.value)}
                  />
                  {/* Ajoutez d'autres options au besoin */}
                </label>
                <label className="labelmenuderoulant">
                  <span className="label">Année de mise en circulation :</span>
                  <input
                    type="text"
                    value={year}
                    onChange={(e) => setYear(e.target.value)}
                  />
                </label>
                <label className="labelmenuderoulant">
                  <span className="label"> Couleur exterieure :</span>
                  <input
                    type="text"
                    value={couleur}
                    onChange={(e) => setCouleur(e.target.value)}
                  />
                </label>
                <label className="labelmenuderoulant">
                  <span className="label">Options :</span>
                  <input
                    type="text"
                    value={options}
                    onChange={(e) => setOptions(e.target.value)}
                  />
                </label>
                <label className="labelmenuderoulant">
                  <span className="label">Immatriculation :</span>
                  <input
                    type="text"
                    value={immat}
                    onChange={(e) => setImmat(e.target.value)}
                  />
                </label>
                <p style={{ color: "grey" }}>
                  Tous les champs ne sont pas obligatoires
                </p>
                <button type="button" onClick={nextStep}>
                  Suivant
                </button>
              </div>
            )}
            {/* Partie 2 */}
            {step === 2 && (
              <div className="form-step">
                <h2>Étape 2 - Vos coordonnées</h2>
                <br></br>
                <label className="labelmenuderoulant">
                  <span className="label">Nom :</span>
                  <input
                    type="text"
                    value={nom}
                    onChange={(e) => setNom(e.target.value)}
                    required
                  />
                </label>
                <label className="labelmenuderoulant">
                  <span className="label">Numéro de téléphone :</span>
                  <input
                    type="tel"
                    autoComplete="tel"
                    value={numeroTelephone}
                    onChange={(e) => setNumeroTelephone(e.target.value)}
                    required // Add the required attribute
                  />
                </label>
                <div className="form-honeypot" aria-hidden="true">
                  <label htmlFor="reprise-website">Site internet</label>
                  <input id="reprise-website" type="text" value={website} onChange={(e) => setWebsite(e.target.value)} tabIndex="-1" autoComplete="off" />
                </div>
                {submitError && <p className="form-error" role="alert">{submitError}</p>}
                <div className="selectpage">
                  <button type="button" onClick={prevStep}>
                    Précédents
                  </button>
                  <button type="button" onClick={sendForm} disabled={isSending}>
                    {isSending ? "Envoi en cours…" : "Demander mon estimation"}
                  </button>
                </div>
              </div>
            )}
            {/* Partie 4 */}
            {step === 3 && (
              <div className="form-step">
                <h2>Confirmation</h2>
                <p>Votre demande de reprise a été transmise à notre équipe.</p>
              </div>
            )}
          </div>
        </div>
        <Contact />
        <br />
        <div className="bannieredubas">
          <img
            src={process.env.PUBLIC_URL + "/IMG_6557.jpeg"}
            alt="bannieredubas"
            className="bannieredubas"
          />
        </div>
      </div>
    </div>
  );
}

export default RepriseContent;
